// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1G37b","requiredAsterisk":"Info_requiredAsterisk__1UPZl"};